// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Management
const ManageProcessorList = () => import('@/modules/processors/views/management/ManageProcessorList')

var routes = [
    {
        path: '/processors',
        redirect: '/processors/manage/list',
        name: 'Processors',
        component: DefaultContainer,
        children: [
            {
				path: '/processors/manage/list',
                name: 'ManageProcessorList',
                component: ManageProcessorList,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
        ]
    },
];

export default routes;
